import type { SVGProps } from "react";

const SvgUnicreditLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#fff",
      }}
      transform="scale(1.92)"
      d="M0 0h24v24H0z"
    />
    <path
      d="M12.259 6.357s0-.065.195-.325c.195-.259.13-.454 0-.583-.065-.065-1.946-1.168-1.946-1.168-.13-.065-.194-.259-.194-.389 0-.26.194-.454.518-.584 1.168-.324 5.384-.519 6.811-.519h2.011A11.8 11.8 0 0 0 12 0C5.449 0 .13 5.319.13 11.87c0 2.854 1.038 5.514 2.724 7.589 1.492-2.205 5.189-7.394 5.968-8.497.973-1.427 3.437-4.605 3.437-4.605m10.638.778c.584-.584.973-1.103.908-1.557-.064-1.232-1.556-2.205-1.556-2.205l-.065-.065a.9.9 0 0 1 .194.26c.39.908-.259 1.491-.648 1.881-.195.194-3.244 3.048-6.811 6.162-3.114 2.724-6.616 5.513-8.692 7.07-2.854 2.141-3.438 2.465-3.438 2.465-.065.065-.194.065-.324.065-.195 0-.324-.13-.454-.26 0 .065 0 .26.259.584l.13.13c.195.194.454.519.843.778.584.519.843.26 2.076-.648 1.881 1.232 4.151 2.01 6.616 2.01 6.551 0 11.87-5.319 11.87-11.87.13-1.751-.259-3.373-.908-4.8"
      style={{
        fill: "#e00a1e",
        fillRule: "nonzero",
      }}
      transform="translate(5.021 5.137)scale(1.50409)"
    />
    <path
      d="M12.454 6.032c.195-.259.13-.454 0-.583-.065-.065-1.946-1.168-1.946-1.168-.13-.065-.194-.259-.194-.389 0-.26.194-.454.518-.584 1.168-.324 5.384-.519 6.811-.519.649 0 2.011 0 2.854.065.973.065 1.752.26 1.881.714.39.908-.259 1.491-.648 1.881-.195.194-3.244 3.048-6.811 6.162-3.114 2.724-6.616 5.513-8.692 7.07-2.854 2.141-3.438 2.465-3.438 2.465-.065.065-.194.065-.324.065-.324 0-.519-.195-.519-.519 0-.13.065-.195.065-.324 0 0 5.643-8.109 6.616-9.471 1.038-1.362 3.503-4.54 3.503-4.54s.129-.065.324-.325"
      style={{
        fill: "#fff",
      }}
      transform="translate(5.021 5.137)scale(1.50409)"
    />
  </svg>
);
export default SvgUnicreditLogo;
